<div class="modal">
  <header class="modal__header">
    <h2 class="modal__header__title" translate>Create Task</h2>
    <button class="modal__header__close" (click)="close()">
      <i class="icon icon-close_ico"></i>
    </button>
  </header>

  <div class="modal__content">
    <form class="create-container form-group" appFormControlError="taskName" [formErrorControl]="taskName">
      <div class="label" translate>
        Name
        <span class="control-container__required">*</span>
      </div>

      <input [placeholder]="'Task name' | translate" data-cy="name-input" class="control" type="text" [formControl]="taskName" />
    </form>
  </div>

  <div class="modal__actions mt-3">
    <div class="btn-group row-flex row-flex--middle mx-0">
      <button class="btn btn__bordered mr-2" (click)="close()" translate>Cancel</button>
      <btn-loader
        styleClasses="btn__primary"
        [buttonLabel]="'Create' | translate"
        [loading]="(taskCollection.loadingCrud$ | async).creating"
        (applyAction)="submit()"></btn-loader>
    </div>
  </div>
</div>
